import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

const OKTELL_URL = 'http://127.0.0.1:4059'
const OKTELL_COMPANIES_URL = 'http://91.147.104.222:4055'

import {
    GetBoxTemplatesParams,
    GetBoxTemplatesResponse,
    GetDeliveryTypesResponse,
    GetWarehouseParams,
    GetWarehouseResponse,
    OktellClientDraftPayload,
    OktellClientPayload,
    OktellEstimatePayload,
    OktellEstimateResponse,
    OktellGetCitiesParams,
    OktellGetCitiesResponse,
    OktellGetClientResponse,
    OktellGetCommunicationsParams,
    OktellGetCommunicationsResponse,
    OktellGetInvoicesParams,
    OktellGetInvoicesResponse,
    OktellGetWhatsappHistoryParams,
    OktellGetWhatsappHistoryResponse,
    OktellGetWhatsappTokenResponse,
    OktellIsHaveWhatsappResponse,
    OktellMultiorderPayload,
    OtkellGetInvoiceStatusesResponse,
    OktellRandomCallPayload,
    OktellGetReasonsResponse,
    OktellGetDeclineReasonsResponse,
    OktellDeclineCallPayload,
    OktellGetWaitListResponse,
    OktellCreateWaitListParams,
    CreateCallBackPayload,
    OktellGetCompaniesResponse,
    OktellGetActivityTypesResponse,
    OktellGetCargoVolumesResponse,
    OktellGetDirectionTypesResponse,
    OktellGetWaitListParams,
} from '@/core/types/oktell.types'

export class OktellRepository {
    getClientByPhone(phone: string): Promise<AxiosResponse<OktellGetClientResponse>> {
        return http.get(`/crm/api/customers/phone/${phone}`)
    }

    createClient(payload: OktellClientPayload): Promise<AxiosResponse<void>> {
        return http.post('/crm/api/customers', payload)
    }

    getInvoices(
        params: OktellGetInvoicesParams
    ): Promise<AxiosResponse<OktellGetInvoicesResponse>> {
        return http.get('/crm/api/invoices', { params })
    }

    getWaitList(
        params: OktellGetWaitListParams
    ): Promise<AxiosResponse<OktellGetWaitListResponse>> {
        return http.get('cabinet/api/wait-list-statuses/history', { params })
    }

    createWaitList(payload: OktellCreateWaitListParams): Promise<AxiosResponse<void>> {
        return http.post('cabinet/api/wait-list-statuses', payload)
    }

    createWaitListMass(payload: OktellCreateWaitListParams): Promise<AxiosResponse<void>> {
        return http.post('cabinet/api/wait-list-statuses/mass-mark', payload)
    }

    getInvoiceStatuses(): Promise<AxiosResponse<OtkellGetInvoiceStatusesResponse>> {
        return http.get('/crm/api/statuses')
    }

    getInvoice(invoice_id: number): Promise<AxiosResponse<void>> {
        return http.get('')
    }

    getCommunications(
        params: OktellGetCommunicationsParams
    ): Promise<AxiosResponse<OktellGetCommunicationsResponse>> {
        return http.get('/crm/api/calls', { params })
    }

    getCities(params: OktellGetCitiesParams): Promise<AxiosResponse<OktellGetCitiesResponse>> {
        return http.get('/order/api/v1/cities', { params })
    }

    getWhatsappToken(): Promise<AxiosResponse<OktellGetWhatsappTokenResponse>> {
        return http.get('/notification/api/whatsapp/token')
    }

    isHaveWhatsapp(phone: string): Promise<AxiosResponse<OktellIsHaveWhatsappResponse>> {
        return http.post(`/notification/api/whatsapp/phone/${phone}/check`, {})
    }

    sendWhatsappMessage(form_data: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData('/notification/api/whatsapp/message/send', form_data)
    }

    getWhatsappHistory(
        params: OktellGetWhatsappHistoryParams
    ): Promise<AxiosResponse<OktellGetWhatsappHistoryResponse>> {
        return http.get('/notification/api/whatsapp/message', { params })
    }

    getBoxTemplates(
        params: GetBoxTemplatesParams
    ): Promise<AxiosResponse<GetBoxTemplatesResponse>> {
        return http.get('/order/api/v1/box-templates', { params })
    }

    getDeliveryTypes(): Promise<AxiosResponse<GetDeliveryTypesResponse>> {
        return http.get('/order/api/v1/delivery-types')
    }

    getSenderWarehouse(params: GetWarehouseParams): Promise<AxiosResponse<GetWarehouseResponse>> {
        return http.get('/order/api/v1/web/sender-templates/warehouses', { params })
    }

    getReceiverWarehouse(params: GetWarehouseParams): Promise<AxiosResponse<GetWarehouseResponse>> {
        return http.get('/order/api/v1/web/receiver-templates/warehouses', { params })
    }

    estimate(payload: OktellEstimatePayload): Promise<AxiosResponse<OktellEstimateResponse>> {
        return http.post('/order/api/v2/call-center/estimate', payload)
    }

    createMultiorder(payload: OktellMultiorderPayload): Promise<AxiosResponse<void>> {
        return http.post('/order/api/v2/call-center/orders', payload)
    }

    clientDraft(payload: OktellClientDraftPayload): Promise<AxiosResponse<void>> {
        return http.post('/crm/api/drafts', payload)
    }

    randomCall(payload: OktellRandomCallPayload): Promise<AxiosResponse<void>> {
        return http.post('/crm/api/calls', payload)
    }

    createCallBack(payload: CreateCallBackPayload): Promise<AxiosResponse<void>> {
        return http.post('/crm/api/call-backs', payload)
    }

    getReasons(): Promise<AxiosResponse<OktellGetReasonsResponse>> {
        return http.get('/crm/api/reasons')
    }

    dialogCardNext(): Promise<AxiosResponse<void>> {
        return http.get(`${OKTELL_URL}/dialogcardnext`)
    }

    getCompanyName(id: number): Promise<AxiosResponse<OktellGetCompaniesResponse>> {
        return http.get(`/crm/api/oktell/company/${id}`, {
            params: { id },
        })
    }

    getActivityTypes(): Promise<AxiosResponse<OktellGetActivityTypesResponse>> {
        return http.get('/crm/api/customers/activity-types')
    }

    getCargoVolumes(): Promise<AxiosResponse<OktellGetCargoVolumesResponse>> {
        return http.get('/crm/api/customers/cargo-volumes')
    }

    getDirectionTypes(): Promise<AxiosResponse<OktellGetDirectionTypesResponse>> {
        return http.get('/crm/api/customers/directions-types')
    }

    getDeclineReasons(): Promise<AxiosResponse<OktellGetDeclineReasonsResponse>> {
        return http.get('/crm/api/refusal-reasons')
    }

    declineCall(payload: OktellDeclineCallPayload): Promise<AxiosResponse<void>> {
        return http.post('/crm/api/refusal', payload)
    }
}
